import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyValueChangeEvent } from '@ngx-formly/core/lib/models';
import { distinctUntilChanged, filter, Subscription } from 'rxjs';

@Component({
  selector: 'irembogov-custom-date-time-picker',
  templateUrl: './custom-date-time-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomDateTimePickerComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit, OnDestroy
{
  constructor(private readonly cd: ChangeDetectorRef) {
    super();
  }

  private readonly subscription: Subscription | undefined;

  ngOnInit(): void {
    this.field.options?.fieldChanges
      ?.pipe(
        filter(
          (change: FormlyValueChangeEvent) =>
            this.field.key === change.field.key
        ),
        distinctUntilChanged((a, b) => {
          return this.deepEqual(a, b);
        })
      )
      .subscribe(() => {
        this.cd.detectChanges();
      });
  }

  private deepEqual(obj1: unknown, obj2: unknown): boolean {
    if (obj1 === obj2) return true;

    if (
      typeof obj1 !== 'object' ||
      obj1 === null ||
      typeof obj2 !== 'object' ||
      obj2 === null
    ) {
      return false;
    }

    const keys1 = Object.keys(obj1) as Array<keyof typeof obj1>;
    const keys2 = Object.keys(obj2) as Array<keyof typeof obj2>;

    if (keys1.length !== keys2.length) return false;

    for (const key of keys1) {
      if (!keys2.includes(key) || !this.deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
